import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { HighRisk } from "ui/organizms/Onboarding";

const HighRiskApplications = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Onboarding | Applications | High Risk'
    >
        <HighRisk.HighRiskApplications />
    </Screen>
);

export default memo(HighRiskApplications);
